import '@vebox/etui-system';
import { makeMedia } from '../utilities/responsive.js';

const dimensionNames = ['xs', 'sm', 'md', 'lg'];
const media = theme => {
  const breakpoints = dimensionNames.reduce((current, item, index) => {
    current[item] = index === 0 ? `0px` : theme.breakpoints[index];
    return current;
  }, {});
  return Object.keys(breakpoints).reduce((m, breakpoint) => {
    const breakpointWidth = breakpoints[breakpoint];
    m[breakpoint] = makeMedia(['only screen', breakpoint !== 0 && `(min-width: ${breakpointWidth})`].filter(Boolean).join(' and '));
    return m;
  }, {});
};

export { dimensionNames, media };
